import React, { useEffect, useState } from "react";
import { AlertTriangle, ExternalLink, X } from "lucide-react";
import { api } from "../lib/api";

/**
 * EmailStatusBanner
 * Persistent Admin banner that warns when Resend is running in sandbox mode
 * (SENDER_EMAIL = onboarding@resend.dev). In that mode Resend refuses to send
 * emails to anyone except the account owner, which was the exact reason our
 * 2 newsletter subscribers were not receiving anything.
 */
export const EmailStatusBanner = () => {
  const [warning, setWarning] = useState(null);
  const [sender, setSender] = useState("");
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/admin/email-status");
        if (r.data.is_sandbox && r.data.warning) {
          setWarning(r.data.warning);
          setSender(r.data.sender_email || "");
        }
      } catch (_) {}
    })();
  }, []);

  if (!warning || dismissed) return null;

  return (
    <div
      className="mb-6 border-2 border-red-500/60 bg-red-500/10 p-4 rounded-sm relative"
      role="alert"
      data-testid="email-status-banner"
    >
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Chiudi"
        className="absolute top-2 right-2 h-7 w-7 flex items-center justify-center text-white/50 hover:text-white transition-colors"
        data-testid="email-status-dismiss"
      >
        <X size={16} />
      </button>
      <div className="flex items-start gap-3 pr-8">
        <AlertTriangle size={22} className="text-red-400 shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-bold text-red-200 leading-tight mb-1.5">
            Email newsletter bloccate — configurazione Resend incompleta
          </p>
          <p className="text-xs text-white/80 leading-relaxed mb-3">
            {warning}
          </p>
          <p className="text-[11px] text-white/60 mb-3">
            Mittente attuale: <code className="bg-black/40 px-1.5 py-0.5 rounded text-red-300">{sender}</code>
          </p>
          <div className="flex flex-wrap gap-2">
            <a
              href="https://resend.com/domains"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-2 bg-red-500 hover:bg-red-400 text-white text-[11px] uppercase tracking-wider font-bold rounded-sm transition-colors"
              data-testid="email-status-verify-btn"
            >
              <ExternalLink size={12} strokeWidth={2.5} />
              Verifica dominio su Resend
            </a>
          </div>
          <p className="text-[10px] text-white/50 mt-3 leading-relaxed">
            Dopo la verifica, aggiorna la variabile <code className="bg-black/40 px-1 rounded">SENDER_EMAIL</code> nella
            Deploy Config di Emergent (es. <code className="bg-black/40 px-1 rounded">no-reply@guzzardellauto.com</code>)
            e ripubblica.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailStatusBanner;
